import type { ReactNode } from 'react';

import { SkeletonRectangle } from '@/components/loaders';
import { Link, Text, Title } from '@/components/typography';
import { cn } from '@/lib/utils';

type Props = {
  title: ReactNode | undefined;
  subtitleLabel?: ReactNode;
  subtitle?: ReactNode;
  subtitleLink?: string;
  subtitleLinkExternal?: boolean;
  hasSubtitle?: boolean;
  isLoading?: boolean;
};

const DetailPageTitle = ({
  title,
  subtitleLabel,
  subtitle,
  subtitleLink,
  subtitleLinkExternal = false,
  isLoading,
  hasSubtitle = true,
}: Props) => {
  return (
    <div className="flex flex-col gap-2">
      {isLoading ? <SkeletonRectangle width={300} height={32} /> : <Title level="3">{title}</Title>}
      {hasSubtitle &&
        (isLoading ? (
          <Text className={cn('flex gap-1.5')} variant="body1">
            {subtitleLabel}: <SkeletonRectangle width={162} height={20} />
          </Text>
        ) : (
          subtitleLabel &&
          subtitle && (
            <Text className={cn('flex gap-1.5')} variant="body1">
              {subtitleLabel}:{' '}
              {subtitleLink ? (
                <Link
                  to={subtitleLink}
                  target={subtitleLinkExternal ? '_blank' : undefined}
                  showExternalIcon={subtitleLinkExternal}
                >
                  {subtitle}
                </Link>
              ) : (
                subtitle
              )}
            </Text>
          )
        ))}
    </div>
  );
};

export default DetailPageTitle;
